/**
 * MigrationApp - Cognito Authentication Version
 * 
 * This is the ACTIVE app when REACT_APP_USE_COGNITO=true
 * Uses AWS Cognito for authentication with invite-only access
 * 
 * Key Components:
 * - CognitoLogin: Login component with password challenge support
 * - CognitoAuthContext: AWS Cognito authentication context
 * - AdminPanel: Admin features for inviting users
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CognitoAuthProvider, useCognitoAuth } from '../contexts/CognitoAuthContext';
import CognitoHeader from './CognitoHeader';
import CognitoLogin from './CognitoLogin';
import CognitoDashboard from './CognitoDashboard';
import AdminPanel from './AdminPanel';
import CognitoProtectedRoute from './CognitoProtectedRoute';

const AppRoutes: React.FC = () => {
  const { isAuthenticated, isAdmin, loading } = useCognitoAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <>
      <CognitoHeader />
      <main className="main-content">
        <Routes>
          <Route 
            path="/" 
            element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/login" 
            element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <CognitoLogin />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              <CognitoProtectedRoute>
                <CognitoDashboard />
              </CognitoProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <CognitoProtectedRoute>
                {isAdmin ? <AdminPanel /> : <Navigate to="/dashboard" replace />}
              </CognitoProtectedRoute>
            } 
          />
        </Routes>
      </main>
    </>
  );
};

function MigrationApp() {
  return (
    <CognitoAuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </CognitoAuthProvider>
  );
}

export default MigrationApp;